// Thin wrapper around @capacitor/splash-screen so the rest of the app can
// call a single hideSplashScreen() that:
//   - is idempotent (safe to call from multiple places; only fires once)
//   - is a no-op on web (Capacitor.isNativePlatform() is false there)
//
// The splash is configured as launchAutoHide:false in capacitor.config.json,
// so it stays until we explicitly hide it. Call sites:
//   - NewHomePage: hides when the first marketplace home data is ready
//     (cache hit = immediate, cache miss = after fetch)
//   - src/index.js: global safety-net timeout in case the user lands on a
//     non-home route, so the splash is never stuck indefinitely

import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';

let hidden = false;

/**
 * Hide the Capacitor splash screen. No-op on web. Safe to call repeatedly;
 * only the first invocation fires the native hide.
 */
export const hideSplashScreen = async () => {
  if (hidden) return;
  hidden = true;
  if (!Capacitor.isNativePlatform()) return;
  try {
    if (SplashScreen && typeof SplashScreen.hide === 'function') {
      await SplashScreen.hide({ fadeOutDuration: 300 });
    }
  } catch (err) {
    console.error('[splash] hide failed', err);
  }
};
